import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePairAssignmentsInputClass;
function SavePairAssignmentsInput() {
  if (SavePairAssignmentsInputClass === VOID) {
    class $ {
      constructor(partyId, pairingSetId, date, pairs, discordMessageId, slackMessageId) {
        discordMessageId = discordMessageId === VOID ? Absent_getInstance() : discordMessageId;
        slackMessageId = slackMessageId === VOID ? Absent_getInstance() : slackMessageId;
        this.y6o_1 = partyId;
        this.z6o_1 = pairingSetId;
        this.a6p_1 = date;
        this.b6p_1 = pairs;
        this.c6p_1 = discordMessageId;
        this.d6p_1 = slackMessageId;
      }
      toString() {
        return 'SavePairAssignmentsInput(partyId=' + this.y6o_1.toString() + ', pairingSetId=' + this.z6o_1.toString() + ', date=' + this.a6p_1.toString() + ', pairs=' + toString(this.b6p_1) + ', discordMessageId=' + toString(this.c6p_1) + ', slackMessageId=' + toString(this.d6p_1) + ')';
      }
      hashCode() {
        var result = this.y6o_1.hashCode();
        result = imul(result, 31) + this.z6o_1.hashCode() | 0;
        result = imul(result, 31) + this.a6p_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.b6p_1) | 0;
        result = imul(result, 31) + hashCode(this.c6p_1) | 0;
        result = imul(result, 31) + hashCode(this.d6p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePairAssignmentsInput()))
          return false;
        if (!this.y6o_1.equals(other.y6o_1))
          return false;
        if (!this.z6o_1.equals(other.z6o_1))
          return false;
        if (!this.a6p_1.equals(other.a6p_1))
          return false;
        if (!equals(this.b6p_1, other.b6p_1))
          return false;
        if (!equals(this.c6p_1, other.c6p_1))
          return false;
        if (!equals(this.d6p_1, other.d6p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePairAssignmentsInput');
    SavePairAssignmentsInputClass = $;
  }
  return SavePairAssignmentsInputClass;
}
//region block: exports
export {
  SavePairAssignmentsInput as SavePairAssignmentsInput3tgrc8c2zd524,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsInput.mjs.map
